Object.defineProperty(exports, "__esModule", { value: true });
exports.docsQuery = void 0;
exports.docsQuery = {
    componentName: 'docs',
    query: `
  {
    docs: allContentfulDocs {
      edges {
        node {
          id
          node_locale
          slug
        }
      }
    }
  }
`,
    type: 'subPage',
};
//# sourceMappingURL=query.js.map